import { ENRICHMENT_ANSWER_TYPE_TEXT } from "../enrichmentAnswerTypes";

export function isEnrichmentAnswerTypeText(enrichment) {
    return enrichment.answer_type == ENRICHMENT_ANSWER_TYPE_TEXT;
}
